/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { AppState } from "../..";

//import { createSelector } from "@reduxjs/toolkit";

export const selectedDeviceSelector = (state: AppState) => state.device.selectedDevice;
export const selectedDeviceAlarmsSelector = (state: AppState) => state.device.selectedDeviceAlarms;
export const selectedDeviceAlarmCountSelector = (state: AppState) => state.device.selectedDeviceAlarmCount;
export const deviceDataCountSelector = (state: AppState) => state.device.deviceDataCount;
export const drawerCountsSelector = (state: AppState) => state.device.drawerCounts;
export const noOfSelectedRowSelector = (state: AppState) => state.device.noOfSelectedRow;
export const deviceActionSelector = (state: AppState) => state.device.deviceAction;
export const deviceTemplateSelector = (state: AppState) => state.device.selectedTemplate;
export const selectedTypeSelector = (state: AppState) => state.device.selectedType;
export const globalTemplateSelector = (state: AppState) => state.device.globalTemplate;
export const isOpenDeviceDrawerSelector = (state: AppState) => state.device.isOpenDeviceDrawer;
export const selectedRnCellConfigSelector = (state: AppState) => state.device.selectedRnCellConfig;
export const radioFirstLteCellSelector = (state: AppState) => state.device.radioFirstLteCellconfig;
export const radioSecondLteCellSelector = (state: AppState) => state.device.radioSecondLteCellconfig;
export const radioNodeSelector = (state: AppState) => state.device.selectedRadioNode;
export const isOpenRnDrawerSelector = (state: AppState) => state.device.isOpenRnDrawer;
export const distributedNodeSelector = (state: AppState) => state.device.selectedDuNode;
export const radioFirstNrCellSelector = (state: AppState) => state.device.radioFirstNrCellconfig;
export const radioSecondNrCellSelector = (state: AppState) => state.device.radioSecondNrCellconfig;
export const isOpenDuDrawerSelector = (state: AppState) => state.device.isOpenDuDrawer;
export const isOpenRnCuDrawerSelector = (state: AppState) => state.device.isOpenRnCuDrawer;
export const isOpenLteDrawerSelector = (state: AppState) => state.device.isOpenLteDrawer;
export const isOpenNRDrawerSelector = (state: AppState) => state.device.isOpenNrDrawer;
export const isOpenCellDrawerSelector = (state: AppState) => state.device.isOpenCellDrawer;
export const siteOfflineSelector = (state: AppState) => state.device.initialSiteDetails;
export const isCellSavedSelector = (state: AppState) => state.device.isCellSaved;
export const isNoteSelector = (state: AppState) => state.device.selectedNote;
export const labelListSelector = (state: AppState) => state.device.labelList;
export const deviceIdSelector = (state: AppState) => state.device.selectedDeviceId;
export const selectedGeoRegionsSelector = (state: AppState) => state.device.selectedGeoRegions;

